import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelText as _vModelText, Teleport as _Teleport, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "card h-100 text-center rounded-0 p-1 flex-row justify-content-between bg-dark border-dark text-white" }
const _hoisted_2 = { class: "dropdown b-dropdown mx-md-4 dropup btn-group" }
const _hoisted_3 = {
  type: "button",
  class: "btn dropdown-toggle btn-secondary",
  "data-bs-toggle": "dropdown"
}
const _hoisted_4 = {
  tabindex: "-1",
  class: "dropdown-menu"
}
const _hoisted_5 = {
  role: "presentation",
  style: {"min-width":"250px"}
}
const _hoisted_6 = {
  tabindex: "-1",
  class: "px-3"
}
const _hoisted_7 = { class: "input-group my-1 input-group-sm" }
const _hoisted_8 = { class: "input-group-prepend" }
const _hoisted_9 = { class: "input-group-text" }
const _hoisted_10 = ["value"]
const _hoisted_11 = { class: "input-group my-1 input-group-sm" }
const _hoisted_12 = { class: "input-group-prepend" }
const _hoisted_13 = { class: "input-group-text" }
const _hoisted_14 = { class: "input-group my-1 input-group-sm" }
const _hoisted_15 = { class: "input-group-prepend" }
const _hoisted_16 = { class: "input-group-text" }
const _hoisted_17 = { class: "dropdown b-dropdown mx-md-4 dropup" }
const _hoisted_18 = ["disabled"]
const _hoisted_19 = {
  tabindex: "-1",
  class: "dropdown-menu dropdown-menu-right"
}
const _hoisted_20 = ["id"]
const _hoisted_21 = { class: "modal-dialog" }
const _hoisted_22 = { class: "modal-content" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("div", { class: "modal-header" }, [
  /*#__PURE__*/_createElementVNode("h5", { class: "modal-title" }, " Downloads "),
  /*#__PURE__*/_createElementVNode("button", {
    type: "button",
    class: "btn-close",
    "data-bs-dismiss": "modal"
  })
], -1)
const _hoisted_24 = { class: "modal-body" }
const _hoisted_25 = { class: "my-4" }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("div", { class: "modal-footer" }, [
  /*#__PURE__*/_createElementVNode("button", {
    type: "button",
    class: "btn btn-secondary",
    "data-bs-dismiss": "modal"
  }, " Close ")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("button", _hoisted_3, _toDisplayString(_ctx.t('download.settings.label')), 1),
        _createElementVNode("ul", _hoisted_4, [
          _createElementVNode("li", _hoisted_5, [
            _createElementVNode("form", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.t('download.settings.form.type.label')), 1)
                ]),
                _withDirectives(_createElementVNode("select", {
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedType) = $event)),
                  class: "text-nowrap custom-select form-select"
                }, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.supportTypes, ([key, value]) => {
                    return (_openBlock(), _createElementBlock("option", {
                      key: key,
                      value: key
                    }, _toDisplayString(value), 9, _hoisted_10))
                  }), 128))
                ], 512), [
                  [_vModelSelect, _ctx.selectedType]
                ])
              ]),
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("div", _hoisted_12, [
                  _createElementVNode("div", _hoisted_13, _toDisplayString(_ctx.t('download.settings.form.quality.label')), 1)
                ]),
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.quality) = $event)),
                  type: "number",
                  min: "1",
                  max: "100",
                  step: "1",
                  class: "form-control"
                }, null, 512), [
                  [_vModelText, _ctx.quality]
                ])
              ]),
              _createElementVNode("div", _hoisted_14, [
                _createElementVNode("div", _hoisted_15, [
                  _createElementVNode("div", _hoisted_16, _toDisplayString(_ctx.t('download.settings.form.pattern.label')), 1)
                ]),
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.nameTransformPattern) = $event)),
                  type: "text",
                  placeholder: "",
                  class: "form-control"
                }, null, 512), [
                  [_vModelText, _ctx.nameTransformPattern]
                ])
              ])
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_17, [
        _createElementVNode("button", {
          type: "button",
          disabled: _ctx.disabledDownload,
          class: "btn dropdown-toggle btn-secondary btn-block",
          "data-bs-toggle": "dropdown"
        }, _toDisplayString(_ctx.t('download.download.label')), 9, _hoisted_18),
        _createElementVNode("ul", _hoisted_19, [
          _createElementVNode("li", null, [
            _createElementVNode("button", {
              type: "button",
              class: "dropdown-item",
              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.downloadAll()))
            }, _toDisplayString(_ctx.t('download.download.all.label')), 1)
          ]),
          _createElementVNode("li", null, [
            _createElementVNode("button", {
              type: "button",
              class: "dropdown-item",
              onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.downloadAll('zip')))
            }, _toDisplayString(_ctx.t('download.download.zip.label')), 1)
          ])
        ])
      ])
    ]),
    (_openBlock(), _createBlock(_Teleport, { to: "#modal-container" }, [
      _createElementVNode("div", {
        id: `modal-download-${_ctx.componentID}`,
        ref: "modalStatus",
        class: "modal fade",
        "data-bs-backdrop": "static",
        "data-bs-keyboard": "false",
        tabindex: "-1"
      }, [
        _createElementVNode("div", _hoisted_21, [
          _createElementVNode("div", _hoisted_22, [
            _hoisted_23,
            _createElementVNode("div", _hoisted_24, [
              _createElementVNode("p", _hoisted_25, _toDisplayString(_ctx.t('download.modal.progress.text')), 1)
            ]),
            _hoisted_26
          ])
        ])
      ], 8, _hoisted_20)
    ]))
  ], 64))
}